module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "uk-form-icon"
  }, [_c('uk-icon', {
    attrs: {
      "name": _vm.icon
    }
  }), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-518b4df5!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UkFormIcon.vue
// module id = 292
// module chunks = 2